import logo from './logo.svg';
import './App.css';

function activateLasers() {
  window.close();
}

function App() {

  function startVideoWithParameter() {
    window.FXMAndroidTheoPlayer.setSource('https://storage.googleapis.com/shaka-demo-assets/bbb-dark-truths-hls/hls.m3u8', 'application/x-mpegurl');
    window.FXMAndroidTheoPlayer.play();
  }

  function startVideoWithoutParameter() {
    window.FXMAndroidTheoPlayer.setSourceDefault();
    window.FXMAndroidTheoPlayer.play();
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          {/*Edit <code>src/App.js</code> and save to reload.*/}
        </p>
        {/*<a*/}
        {/*  className="App-link"*/}
        {/*  href="https://reactjs.org"*/}
        {/*  target="_blank"*/}
        {/*  rel="noopener noreferrer"*/}
        {/*>*/}
        {/*  Learn React*/}
        {/*</a>*/}
        <button onClick={startVideoWithParameter}>
          Start Video with Parameter
        </button>
        <button onClick={startVideoWithoutParameter}>
          Start Video without Parameter
        </button>
      </header>
    </div>
  );
}

export default App;
